import { useContext } from 'react';
import { MessagesContext } from '../contexts/messages_context';

const useMessages = () => {
    return useContext(MessagesContext);
};

export default useMessages;
